import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogClose } from '@/components/ui/dialog';
import { X, HelpCircle } from 'lucide-react';

export const TutorialIconButton = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsVideoOpen(true)}
        className="p-2 hover:bg-gray-100"
        title="Tutorial ansehen"
      >
        <HelpCircle className="w-4 h-4" />
      </Button>

      <Dialog open={isVideoOpen} onOpenChange={setIsVideoOpen}>
        <DialogContent className="sm:max-w-4xl">
          <DialogHeader className="text-lg font-semibold">
            KaufPause Tutorial - So nutzt du die App optimal
            <DialogClose className="absolute right-4 top-4">
              <X className="h-4 w-4" />
              <span className="sr-only">Schließen</span>
            </DialogClose>
          </DialogHeader>
          <div className="aspect-video w-full overflow-hidden rounded-md">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube-nocookie.com/embed/_53vpTe-JOA"
              title="KaufPause Tutorial - So nutzt du die App optimal"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              className="rounded-md"
            ></iframe>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}; 